export const HOME = "HOME";
export const CAREER = "CAREER";
export const CONTACT = "CONTACT";
export const GALLERY = "GALLERY";
export const NEWS = "NEWS";
export const WHO_WE_ARE = "WHO_WE_ARE";
